"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _tslib = require("tslib");
var _vue = _interopRequireDefault(require("vue"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/PanThumb/index.vue"));
var UserCard = /*#__PURE__*/function (_Vue) {
  function UserCard() {
    (0, _classCallCheck2.default)(this, UserCard);
    return (0, _callSuper2.default)(this, UserCard, arguments);
  }
  (0, _inherits2.default)(UserCard, _Vue);
  return (0, _createClass2.default)(UserCard, [{
    key: "user",
    get: function get() {
      return this.$store.state.user.info;
    }
  }]);
}(_vue.default);
UserCard = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    PanThumb: _index.default
  }
})], UserCard);
var _default = exports.default = UserCard;